import styled from 'styled-components';

export const StyledSpacingWrapper = styled.div<{ removeLeft?: boolean }>`
  margin: ${({ theme }): string => `${theme.spacing_unit_x2} 0`};
  margin-left: ${({ removeLeft }): string => (removeLeft ? '-8px' : '0px')};
`;
